import Grid from '@mui/material/Grid';
import logo from './logo.png';

// SARTRASのロゴ
function Logo() {
  return (
    <Grid container spacing={3} alignItems='center' justifyContent='center' direction='column'>
      <Grid item xs={12}>
        <img src={logo} style={{
          padding: 20,
          width: 300
        }} />
      </Grid>
    </Grid>
  )
}

export default Logo